/**
 * Graduations d'axe.
 *
 * Deux fonctions, extraites parce que les deux graphes en avaient besoin et
 * que la première version n'en avait aucune : elle étiquetait un point sur
 * trois, ce qui donnait dix-huit dates de cinquante-cinq unités de large sur
 * un axe qui en compte six cent trente. Le résultat était une barre noire.
 *
 * Le nombre de graduations est donc **borné**, jamais déduit du nombre de
 * points.
 */

/**
 * Au plus `maximum` indices régulièrement répartis parmi `count`, bornes
 * comprises. Rend `[]` si `count` est nul, `[0]` s'il vaut un.
 */
export function sampleIndices(count: number, maximum: number): readonly number[] {
  if (count <= 0 || maximum <= 0) return [];
  if (count === 1 || maximum === 1) return [0];
  if (count <= maximum) return Array.from({ length: count }, (_, index) => index);

  const last = count - 1;
  const steps = maximum - 1;
  const indices = Array.from({ length: maximum }, (_, index) =>
    Math.round((index * last) / steps),
  );
  return [...new Set(indices)];
}

/** `count` valeurs régulièrement réparties de `min` à `max`, bornes comprises. */
export function linearTicks(min: number, max: number, count: number): readonly number[] {
  if (count <= 1 || max === min) return [min];
  const steps = count - 1;
  return Array.from({ length: count }, (_, index) => min + ((max - min) * index) / steps);
}

/**
 * Décimales à afficher pour que deux graduations voisines ne se confondent
 * pas. Un axe dont toutes les graduations affichent « 0 » n'informe de rien.
 */
export function tickDecimals(span: number): number {
  if (span >= 20) return 0;
  if (span >= 2) return 1;
  if (span >= 0.2) return 2;
  return 3;
}
